/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjectinterest_Subject_French15Inputs */

const en__field__enum_teachingsubjectinterest_subject_french15 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_French15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`French`)
};

const de__field__enum_teachingsubjectinterest_subject_french15 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_French15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Französisch`)
};

/**
* | output |
* | --- |
* | "French" |
*
* @param {_Field__Enum_Teachingsubjectinterest_Subject_French15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjectinterest_subject_french15 = /** @type {((inputs?: _Field__Enum_Teachingsubjectinterest_Subject_French15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjectinterest_Subject_French15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjectinterest_subject_french15(inputs)
	return de__field__enum_teachingsubjectinterest_subject_french15(inputs)
});
export { _field__enum_teachingsubjectinterest_subject_french15 as "_field__enum_teachingSubjectInterest_SUBJECT_FRENCH" }